import React, { useEffect, useState } from 'react';
import api from '../services/api';

function TestePage() {
  const [status, setStatus] = useState('Iniciando...');
  const [dados, setDados] = useState({});

  useEffect(() => {
    const testarAPI = async () => {
      try {
        setStatus('🔄 Testando API...');
        
        // Pegar ID da URL
        const params = new URLSearchParams(window.location.search);
        const id = params.get('id') || '1';
        
        setStatus(`📍 Testando com ID da loja: ${id}`);
        
        // Testar buscar grupos
        setStatus('📂 Testando buscar_grupo_produtos...');
        const grupos = await api.post('buscar_grupo_produtos', {
          id_loja: id
        });
        
        setStatus('🛍️ Testando buscar_numero_itens...');
        const produtos = await api.post('buscar_numero_itens', {
          id_loja: id,
          query_start: 0,
          query_end: 6,
          gruposquery: '{"grupo":"","preco_minimo":"","preco_maximo":"","ordem":"[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO"}',
          texto: '',
          estoque: grupos.data?.estoque_seguranca || 0
        });
        
        setDados({
          grupos: grupos.data,
          produtos: produtos.data
        });
        
        setStatus('✅ Teste concluído!');
        
      } catch (error) {
        setStatus(`❌ Erro: ${error.message}`);
        console.error('Erro no teste:', error);
      }
    };
    
    testarAPI();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>🧪 Teste de API</h1>
      <p><strong>Status:</strong> {status}</p>
      
      <div style={{ marginTop: '20px' }}>
        <h3>📊 Dados retornados:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '5px', fontSize: '12px' }}>
          {JSON.stringify(dados, null, 2)}
        </pre>
      </div>
    </div>
  );
}

export default TestePage;
